// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15hbw","left":"styles_left__22pu2"};